<template>
	<div class="w1">
	<div  class="Main_wrapper"><!-- Main_wrapper -->
		<ul class="title1">
			<li class="L">中经头条</li>
			<li class="R"></li>
		</ul>
		<itemsearch @showzixunjianyifromsearch="showfankui" v-bind:colid='colid' v-bind:colname='colname' v-bind:colfrom="'toutiao'" @searchshow="searchshow" @searchclose="searchclose"></itemsearch>
		<div v-show="!searchResultShow">
			<el-skeleton :rows="20" :loading="loadingMask" animated :throttle="500">
			<ul  class="zjpl_list" style="min-height: 516px;" ><!-- zjpl_list -->
				<li v-for="(result,index) in resultDataList" :key="result.id" >
					<dl>
						<dt>
							<L>
								<a @click="jumppush('/detail/'+result.id+'/1?col=toutiao')" class="T-tit" target="_blank" v-html="result.title"></a>
							</L>
							<R>{{result.publishtime?result.publishtime.substring(0,10):''}}</R>
						</dt>
					</dl>
				</li>
			</ul><!-- /zjpl_list -->
				
				
				
			<div class="m_b1"></div>
				
				
			<el-row class="pagediv">
				<el-pagination
							@size-change="changePageSize"
							@current-change="changeSearchPage"
							:current-page="pageNum"
							:page-sizes="[10, 15, 20]"
							:page-size="pageSize"
							layout="total, sizes, prev, pager, next, jumper"
							:total="totalResultCount">
						</el-pagination>
			</el-row>
				
			
			</el-skeleton>
		</div>
		
	
	</div><!-- /Main_wrapper -->
	</div>
</template>

<script>
	import itemsearch from '@/components/list-item-search.vue'
	export default {
		data() {
			return {
				hasPower:true,
				loadingMask: true,
				colid:'14f53ae655df407c8eff105594ae4c5e',
				colname:'头条',
				pageNum: 1,
				pageSize: 10,
				totalResultCount: 0,
				resultDataList: [],
				searchResultShow:false,
			}
		},
		components:{
			itemsearch,
		},
		created:function(){
			
		},
		mounted:function(){
			document.title='头条-中经专网';
			this.$track([
				['pagetype','头条列表'],
				['reqtype','2'],
				['column',this.colid]
			]);
			this.searchfnc();
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		methods: {
			authcheck:function(){
				// this.hasPower=false;
				// if(!this.$cookies.get('userauth')){
				// 	this.hasPower=true;
				// }
				// else{
				// 	if(this.$cookies.get('userauth')=='1921f9e1416473a1d0f15d328e837115'){
				// 		this.hasPower=true;
				// 	}
				// 	if(this.$cookies.get('userauth').indexOf('toutiao')>-1){
				// 		this.hasPower=true;
				// 	}
				// }
			},
			jumppush:function(to){
				this.authcheck();
				if(!this.hasPower){
					alert('您未购买此栏目!');
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			searchfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'article/searchArticles',
						responseType: 'json',
						params: {
							columnID:this.colid,
							iPage: this.pageNum,
							pageSize: this.pageSize,
							orderBy:'publishtime',
							isDesc:'1',
						},
					})
					.then(function(response) {
						_this.resultDataList = response.data.data.data.data;
						_this.totalResultCount = response.data.data.data.totalcount;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changePageSize:function(pagesize){
				this.pageSize=pagesize;
				this.searchfnc();
			},
			changeSearchPage: function(page) {
				this.pageNum = page;
				this.searchfnc();
			},
			searchshow:function(key){
				this.searchResultShow=true;
			},
			searchclose:function(){
				this.searchResultShow=false;
			},
			showfankui:function(){
				this.$emit('showzixunjianyifromsearch');
			}
			
		}
	}
</script>

<style>
	
</style>
